import { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useTicket } from '@repo/domain-service';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export default function TicketExistsGuard() {
  const { id } = useParams<{ id: string }>();
  const { ticket, loadingTicket } = useTicket(id!);
  const navigate = useNavigate();

  useEffect(() => {
    if (!id || (!loadingTicket && !ticket)) {
      navigate(ROUTE_PATHS[RouteName.ACCOUNT_TICKETS], { replace: true });
    }
  }, [id, loadingTicket, ticket, navigate]);

  if (!ticket) {
    return null;
  }

  return <Outlet context={ticket} />;
}
